import * as React from "react";
import { MdBalance } from "react-icons/md";
import { useState } from "react";
import DropdownMenu from "../../components/menu/DropdownMenu";
import { menuItems } from "../../components/menu/MenuContent";
import InlineMenu from "../../components/menu/InlineMenu";

export const TopNavbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  return (
    <>
      <ul className="flex items-center">
        <li className="p-2">
          <MdBalance className="text-4xl drop-shadow-md" />
        </li>
        <li className="p-2">
          <p className="font-serif text-2xl">Avv. Mango</p>
        </li>
      </ul>
      <div className="hidden xl:flex items-center">
        <InlineMenu
          menuContent={menuItems}
        />
      </div>
      <div className="flex xl:hidden items-center">
        <DropdownMenu
          buttonName="hamburger"
          setIsAllMenuOpen={setIsMenuOpen}
          isAllMenuOpen={isMenuOpen}
          isChildMenu={false}
          isInline={false}
          menuContent={menuItems}
        />
      </div>
    </>
  );
};
